import {
  SecurityLayout,
  SecuritySigninPage,
  SecuritySignupPage,
  SecurityForgotPage,
  SecurityPasswdPage,
  SecurityGrantPage,
  Security2FAPage
} from 'src/pages'
import i18n from '../../i18n'

const pageByMode = (mode = 'signin') => {
  switch (mode) {
    case 'signup':
      return '/security/signup'
    case 'signin':
    default:
      return '/security/signin'
  }
}

export default ({ store }) => [
  {
    path: '/security',
    component: SecurityLayout,
    children: [
      {
        path: '',
        meta: { requiresNoAuth: true },
        async beforeEnter (to, from, next) {
          const { state, scope, mode, redirect_uri: redirectURI, login, loginType, refcode, ...otherParams } = to.query
          // set language
          if (otherParams.language) {
            i18n.locale = otherParams.language.toLowerCase()
            await store.dispatch('language/selectLanguage', otherParams.language)
          } else {
            i18n.locale = 'en'
            await store.dispatch('language/selectLanguage', 'en')
          }

          await store.dispatch('passport/context', { state, scope, redirectURI, refcode })

          const strategy = store.getters['passport/getStrategyByCallbackUrl'](redirectURI)
          if (!strategy) {
            // TODO @mdkardaev: make error page when show that strategy doesn't exist
            return next(false)
          }

          const path = (store.state.passport.user != null)
            ? '/security/grant'
            : pageByMode(mode)
          next({
            replace: true,
            path,
            query: {
              login,
              loginType,
              ...otherParams
            }
          })
        }
      },
      {
        path: 'confirm/:secret',
        meta: { requiresNoAuth: true },
        async beforeEnter (to, from, next) {
          try {
            const { secret } = to.params
            await store.dispatch('passport/confirmEmailBySecret', { secret })
          } catch (e) {
            // nothing
          }

          // TODO: maybe in case of error redirect to error page?
          next({
            replace: true,
            path: (store.state.passport.user != null)
              ? '/security/grant'
              : '/security/signin'
          })
        }
      },
      {
        path: 'recover/:secret',
        meta: { requiresNoAuth: true },
        async beforeEnter (to, from, next) {
          try {
            const { secret } = to.params
            await store.dispatch('passport/confirmRecoverEmailPasswordBySecret', { secret })
          } catch (e) {
            // nothing
          }

          // TODO: maybe in case of error redirect to error page?
          next({
            replace: true,
            path: (store.state.passport.user != null)
              ? '/security/passwd'
              : '/security/signin'
          })
        }
      },
      {
        path: 'signout',
        async beforeEnter (to, from, next) {
          const { state, scope, redirect_uri: redirectURI, mode, login, loginType, refcode } = to.query

          const strategy = store.getters['passport/getStrategyByCallbackUrl'](redirectURI)
          if (!strategy) {
            // TODO @mdkardaev: make error page when show that strategy doesn't exist
            return next(false)
          }

          // await store.dispatch('passport/serverSignout', { callbackURL: redirectURI })
          await store.dispatch('passport/signout')
          await store.dispatch('passport/context', { state, scope, redirectURI, refcode })

          if (mode === 'autoclose') {
            window.close()
            return
          }

          next({
            replace: true,
            path: 'security/signin',
            query: {
              login,
              loginType
            }
          })
        }
      },
      {
        path: 'signin',
        component: SecuritySigninPage
      },
      {
        path: 'signup',
        component: SecuritySignupPage
      },
      {
        path: 'forgot',
        component: SecurityForgotPage
      },
      {
        path: 'passwd',
        component: SecurityPasswdPage
      },
      {
        path: 'grant',
        component: SecurityGrantPage
      },
      {
        path: '2fa',
        component: Security2FAPage
      }
    ]
  }
]
